import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getItem, StorageItem } from '@core/utils';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const token = <string>(getItem(StorageItem.Token) || '');

    if (!!token) {
      if (request.url.startsWith('/kc_')) {
        request = request.clone({
          headers: request.headers.set('token', token).set('Content-Type', 'application/x-www-form-urlencoded'),
        });
      } else if (request.url.indexOf('uploadSensitives') !== -1 || request.url.indexOf('/upload') !== -1 || request.body instanceof FormData) {
        request = request.clone({
          headers: request.headers.set('token', token),
        });
      } else {
        request = request.clone({
          headers: request.headers.set('token', token).set('Content-Type', 'application/json'),
        });
      }
    } else {
      request = request.clone({
        headers: request.headers.set('Content-Type', 'application/json'),
      });
    }
    return next.handle(request);
  }
}
